import React from 'react';
import './Sobre.css';
import {getImage} from '../../assets/images/index'; 

const Sobre = () => {
  return (
    <div className="about-page">
      <section className="about-brand">
        <div className="about-brand__text">
          <span className="about-brand__eyebrow">Quem Somos</span>
          <h1 className="about-brand__title">Funda&ccedil;&atilde;o Theodomiro Santiago</h1>
          <p className="about-brand__description">
            A Funda&ccedil;&atilde;o Theodomiro Santiago (FTS) &eacute; uma institui&ccedil;&atilde;o de apoio &agrave; Universidade Federal de Itajub&aacute;
            (UNIFEI), comprometida com o incentivo &agrave; pesquisa e &agrave; inova&ccedil;&atilde;o.
          </p>
          <p className="about-brand__description">
            Somos uma entidade jur&iacute;dica de direito privado, sem fins lucrativos, constitu&iacute;da em 23 de novembro de 1960 por iniciativa
            de diplomados do Instituto Eletrot&eacute;cnico de Itajub&aacute; (IEI), sucessor do Instituto Eletrot&eacute;cnico e Mec&acirc;nico de Itajub&aacute;
            (IEMI). Posteriormente, o IEI passou a denominar-se Escola Federal de Engenharia de Itajub&aacute; (EFEI) e, mais tarde, foi transformado
            na UNIFEI. Nossa sede est&aacute; em Itajub&aacute;, Minas Gerais, e seguimos as diretrizes do nosso Estatuto e da legisla&ccedil;&atilde;o vigente.
          </p>
          <p className="about-brand__description">
            A UNIFEI &eacute; uma das universidades mais antigas e respeitadas do Brasil, com mais de 110 anos de tradi&ccedil;&atilde;o, or&ccedil;amento que ultrapassa
            R$ 280 milh&otilde;es e infraestrutura superior a 140 mil m&sup2;. Atualmente, oferece 35 cursos de gradua&ccedil;&atilde;o, 23 programas de p&oacute;s-gradua&ccedil;&atilde;o
            e atende aproximadamente 8 mil alunos.
          </p>
          <p className="about-brand__description">
            A universidade se destaca pela forte capacidade de pesquisa, com 84 grupos que desenvolvem estudos em diversas &aacute;reas do conhecimento.
            O nome Theodomiro Santiago homenageia o fundador da UNIFEI, que estabeleceu a institui&ccedil;&atilde;o em 1913 e deixou um legado de excel&ecirc;ncia
            acad&ecirc;mica e inova&ccedil;&atilde;o cient&iacute;fica.
          </p>
        </div>
      </section>

      <section className="about-photo">
        <img
          src={getImage('unifei1')}
          alt="UNIFEI - Universidade Federal de Itajubá"
          className=""
        />
      </section>
      <section className="about-overview">
        <p className="about-overview__text">
          A Funda&ccedil;&atilde;o Theodomiro Santiago (FTS) tem por objetivo atuar na presta&ccedil;&atilde;o de servi&ccedil;os tecnol&oacute;gicos, de pesquisa e inova&ccedil;&atilde;o,
          desenvolvendo estudos e projetos.
        </p>
        <p className="about-overview__text">
          Al&eacute;m disso, mant&eacute;m viva a mem&oacute;ria de Theodomiro Carneiro Santiago, fundador do Instituto Eletrot&eacute;cnico e Mec&acirc;nico de Itajub&aacute; (IEMI), e de outros que
          contribu&iacute;ram significativamente para a UNIFEI.
        </p>
        <p className="about-overview__text">
          Entre suas iniciativas, a FTS apoia alunos carentes, incentiva a integra&ccedil;&atilde;o entre diplomados e a Universidade, e fomenta o aperfei&ccedil;oamento acad&ecirc;mico por meio
          de eventos, cursos e projetos. A Funda&ccedil;&atilde;o tamb&eacute;m colabora com empresas e institui&ccedil;&otilde;es para o avan&ccedil;o do conhecimento, gerencia o Museu de Ci&ecirc;ncia e
          Tecnologia de Itajub&aacute; e concede a Medalha do M&eacute;rito Theodomiro Santiago a profissionais de destaque na engenharia nacional.
        </p>
        <p className="about-overview__text">
          Al&eacute;m disso, a FTS desenvolve atividades culturais, gerencia espa&ccedil;os e patrim&ocirc;nios hist&oacute;ricos, promove a integra&ccedil;&atilde;o entre Governo, Universidade e Empresas, e apoia
          a UNIFEI no crescimento de suas atividades acad&ecirc;micas e institucionais.
        </p>
        <p className="about-overview__text">
          Com um compromisso s&oacute;lido com a educa&ccedil;&atilde;o, inova&ccedil;&atilde;o e cultura, a Funda&ccedil;&atilde;o Theodomiro Santiago segue impulsionando o desenvolvimento da UNIFEI e da
          comunidade.
        </p>
      </section>

      {/* <section className="about-cards">
        <div className="about-card">
          <div className="about-card__icon about-card__icon--mission">
            <Target aria-hidden="true" />
          </div>
          <h2 className="about-card__title">Nossa Miss&atilde;o</h2>
          <p className="about-card__text">
            Atuar na presta&ccedil;&atilde;o de servi&ccedil;os tecnol&oacute;gicos, de pesquisa e inova&ccedil;&atilde;o, desenvolvendo estudos e projetos que fortale&ccedil;am a UNIFEI e
            gerem impacto positivo para a comunidade acad&ecirc;mica e para a sociedade.
          </p>
        </div>
        <div className="about-card">
          <div className="about-card__icon about-card__icon--vision">
            <Eye aria-hidden="true" />
          </div>
          <h2 className="about-card__title">Nossa Vis&atilde;o</h2>
          <p className="about-card__text">
            Ser refer&ecirc;ncia na integra&ccedil;&atilde;o entre governo, universidade e empresas, preservando o legado de Theodomiro Carneiro Santiago e impulsionando
            o desenvolvimento acad&ecirc;mico, cultural e tecnol&oacute;gico da UNIFEI e de seus parceiros.
          </p>
        </div>
      </section>*/}
    </div> 
  );
};

export default Sobre;
